module.exports = __webpack_public_path__ + "img/hr-curved-rail-vertical-left-top-stone-path-remnants.2a2725e1.png";